/* MYOP header sticky-shrink — toggles .myop-shrunk after a small scroll. */
(function () {
  function init() {
    var headers = document.querySelectorAll('.myop-header-shrinkable');
    if (!headers.length) return;
    var threshold = 40;
    var ticking = false;

    function update() {
      var shrunk = window.scrollY > threshold;
      headers.forEach(function (h) { h.classList.toggle('myop-shrunk', shrunk); });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
